import React from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { apiViaje } from "../../api/viaje";

const apiviaje = new apiViaje();

//discontinuado
const CancelarViajePregunta = async (Id) => {
  Swal.fire({
    title: "¿Vas a cancelar el viaje seleccionado?",
    text: "El viaje no podrá recuperarse posterior a esta acción",
    // type: "warning",
    showCancelButton: true,
    confirmButtonText: "Si",
    confirmButtonColor: estiloColores.Azul,
    cancelButtonText: "Cancelar",
    cancelButtonColor: estiloColores.Gris,
  }).then((result) => {
    if (result.value) {
      CancelarViajePreguntaAccion(Id);
    }
  });
};

//discontinuado
const CancelarViajePreguntaAccion = async (Id) => {
  const respuesta = await apiviaje.cancelar(Id);

  if (respuesta.status === 200) {
    Swal.fire({
      // type: "success",
      title: "Viaje cancelado con éxito",
      text: "",
      timer: 1500,
      showCancelButton: false,
      showConfirmButton: false,
    });

    //refrescar
    //apiviaje.refrescarHome(Id, "", "", "Quitar");
  }
};

//discontinuado
export function CancelarViaje({ Id }) {
  return (
    <div>
      <IconButton
        aria-label="delete"
        style={{ color: "#DC030E" }}
        onClick={() => {
          CancelarViajePregunta(Id);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );
}
